import { render, staticRenderFns } from "./PlatformWealthRecordList.vue?vue&type=template&id=0098cf0a&scoped=true&lang=pug&"
import script from "./PlatformWealthRecordList.vue?vue&type=script&lang=ts&"
export * from "./PlatformWealthRecordList.vue?vue&type=script&lang=ts&"
import style0 from "./PlatformWealthRecordList.vue?vue&type=style&index=0&id=0098cf0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0098cf0a",
  null
  
)

export default component.exports